import { Controller } from "stimulus";

export default class extends Controller {

  static targets = ["submitCategoriesBtn", "notifications", "loadMoreProductsBtn", "spinner"];
  
  connect() {

    document.querySelectorAll(".category-container").forEach((container) => {
      var subcategoriesCount = container.querySelectorAll(".subcategory").length
      var checkedSubcategoriesCount = container.querySelectorAll(".subcategory:checked").length;
      if (checkedSubcategoriesCount > 0 && checkedSubcategoriesCount < subcategoriesCount) {
        container.querySelector(".parent-category").indeterminate = true;
      }
    });

  }

  toggleNotifications(e) {
    console.log("OK");
    this.notificationsTarget.classList.toggle("hidden");
  }



  toggleSubcategories(e) {
    var categoryID = e.target.dataset.category;
    var subcategoriesList = document.querySelector(`#subcategories_for_${categoryID}`);


    document.querySelectorAll(".subcategories-list").forEach((sublist) => {
      if (subcategoriesList != sublist) sublist.classList.add("hidden");
    });

    if (!!subcategoriesList && subcategoriesList.querySelectorAll("input").length > 0) {

      subcategoriesList.classList.toggle("hidden");
    }
  }

  selectCategory(e) {
    // data-select-parent-category
    console.log(e.target);


    if (!!e.target.dataset.autoselectCategory) {
      var isChecked = !!e.target.checked;
      var parentCategoryID = e.target.dataset.autoselectCategory;
      document.querySelector(`#category_${parentCategoryID}`).checked = isChecked;
      document.querySelectorAll(`#subcategories_for_${parentCategoryID} input[type=checkbox]`).forEach((checkbox) => {
        checkbox.checked = isChecked;
      });

    }

    var categoryName = e.target.parentElement.innerText.trim();

    if (categoryName.toLowerCase() == "componi la tua tisana" && e.target.checked) {
      window.open("/shop/tisane", '_blank');
    }
    
    this.submitCategoriesBtnTarget.click();
  }



  toggleSubcategoriesMobile(e) {
   

    var categoryID = e.target.dataset.category;
    var subcategoriesList = document.querySelector(`#mobileCategoriesMenu #subcategories_for_${categoryID}`);


    document.querySelectorAll("#mobileCategoriesMenu .subcategories-list").forEach((sublist) => {
      if (subcategoriesList != sublist) sublist.classList.add("hidden");
    });

    if (!!subcategoriesList && subcategoriesList.querySelectorAll("input").length > 0) {

      console.log( subcategoriesList.classList.contains("hidden"));

      subcategoriesList.classList.toggle("hidden");
    }
  }

  selectCategoryMobile(e) {
    // data-select-parent-category
    console.log(e.target);


    if (!!e.target.dataset.autoselectCategory) {
      var isChecked = !!e.target.checked;
      var parentCategoryID = e.target.dataset.autoselectCategory;
      document.querySelector(`#mobileCategoriesMenu #category_${parentCategoryID}`).checked = isChecked;
      document.querySelectorAll(`#mobileCategoriesMenu #subcategories_for_${parentCategoryID} input[type=checkbox]`).forEach((checkbox) => {
        checkbox.checked = isChecked;
      });

    }

    var categoryName = e.target.parentElement.innerText.trim();

    if (categoryName.toLowerCase() == "componi la tua tisana" && e.target.checked) {
      window.open("/shop/tisane", '_blank');
    }
    
    this.submitCategoriesBtnTarget.click();
  }


  loadMoreProducts(e) {
    e.preventDefault()
    console.log("load")
    // if (this.element.dataset.loadingProducts == true) return;
    var body = document.body
    var html = document.documentElement
    var height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight)
    var loadProductsTriggerOffset = 300
     if (window.pageYOffset >= (height - window.innerHeight - loadProductsTriggerOffset)) {
      if (this.hasLoadMoreProductsBtnTarget) {
        this.loadMoreProductsBtnTarget.click()
        this.element.dataset.loadingProducts = true;
        this.loadMoreProductsBtnTarget.classList.add("hidden")
        this.spinnerTarget.classList.remove("hidden")

        setTimeout(() => {
          this.element.dataset.loadingProducts = false;
        }, 500);
      }
     }
    
  }

}